import { Checkbox, SxProps, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  TableCellFixedWidth,
  TableCellWide,
} from "../../../../common/components/functional/GroupedTable/styled";
import { TalentWorkOfferStatus } from "../../orderAPI";
import StateCircleFilled from "../../../../common/icons/stateCircleFilled.svg";
import StateCircleUnfilled from "../../../../common/icons/stateCircleUnfilled.svg";
import {
  TALENT_OFFER_ACCEPTED,
  TALENT_OFFER_DECLINED,
  TALENT_OFFER_OFFERED,
} from "../../constants";
import { getName } from "../../../../common/helpers/common";
import { isFormerUser } from "../../isFormerUser";
import { TalentNameWithPreview } from "../long/talentsStatus/TalentNameWithPreview";

type Props = {
  talentWorkOffer: TalentWorkOfferStatus;
  selected?: boolean;
  onSelect?: (talentId: string) => void;
  sx?: SxProps;
  isOrderFulfilled: boolean;
};

export const ShortOrderWorkOfferRow = ({
  talentWorkOffer,
  selected = false,
  onSelect,
  sx,
  isOrderFulfilled,
}: Props) => {
  const { t } = useTranslation("order");
  const borderStyle = "1px solid rgba(0, 10, 68, 0.11)";

  return (
    <TableRow sx={sx}>
      <TableCellFixedWidth sx={{ border: "none" }}>
        <Checkbox
          disabled={
            !talentWorkOffer.manuallyOffered ||
            talentWorkOffer.workOfferStatus !== TALENT_OFFER_OFFERED ||
            isOrderFulfilled
          }
          checked={selected}
          onClick={() => onSelect && onSelect(talentWorkOffer.id)}
        />
      </TableCellFixedWidth>
      <TableCellWide sx={{ border: "none" }}>
        <TalentNameWithPreview
          talentId={talentWorkOffer.id}
          fullName={
            isFormerUser(talentWorkOffer)
              ? t("formerUser")
              : getName(talentWorkOffer)
          }
        />
      </TableCellWide>
      <TableCellFixedWidth
        sx={{
          borderLeft: borderStyle,
          borderTop: "none",
          borderBottom: "none",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <img
          src={StateCircleFilled}
          alt={"circleFilled"}
          style={{
            width: "20px",
            height: "20px",
          }}
        />
      </TableCellFixedWidth>
      <TableCellFixedWidth
        sx={{
          borderLeft: borderStyle,
          borderTop: "none",
          borderBottom: "none",
          textAlign: "center",
        }}
      >
        {talentWorkOffer.workOfferStatus === TALENT_OFFER_ACCEPTED ? (
          <img
            src={StateCircleFilled}
            alt={"circleFilled"}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        ) : (
          <img
            src={StateCircleUnfilled}
            alt={"circleUnfilled"}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        )}
      </TableCellFixedWidth>
      <TableCellFixedWidth
        sx={{
          borderLeft: borderStyle,
          borderRight: borderStyle,
          borderTop: "none",
          borderBottom: "none",
          textAlign: "center",
        }}
      >
        {talentWorkOffer.workOfferStatus === TALENT_OFFER_DECLINED ? (
          <img
            src={StateCircleFilled}
            alt={"circleFilled"}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        ) : (
          <img
            src={StateCircleUnfilled}
            alt={"circleUnfilled"}
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        )}
      </TableCellFixedWidth>
    </TableRow>
  );
};
